/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpToDoubleLine: {
  name: 'arrow-up-to-double-line';
  data: string;
} = {
  name: 'arrow-up-to-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm7 14v-6.586l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4A.997.997 0 0 0 12.001 9H17a1 1 0 1 0 0-2H7a1 1 0 0 0 0 2h5a.997.997 0 0 0-.707.293l-4 4a1 1 0 1 0 1.414 1.414L11 12.414V19a1 1 0 1 0 2 0Z" fill="currentColor"/></svg>`,
};
